import React from "react"
import { Headline } from "@shared"
import styles from "@pageStyles/resources.module.scss"
import { css } from "@jsUtils"
import { FILTERS } from "@data/constants"

const ResourcesHeader = ({ filter, menu, setMenu }) => {
  // determine subhead text based on active filter
  const activeFilterIndex = FILTERS.findIndex(x => x.value === filter)
  const activeFilterText = FILTERS[activeFilterIndex].buttonText

  return (
    <>
      <div className={styles.header}>
        <Headline className={styles.headerHeading} size={3}>
          Resources
        </Headline>

        <button className={styles.menu} onClick={() => setMenu(!menu)} type="button">
          <p className={css(styles.menuHeading, menu && styles.open)}>Topics</p>

          <div className={css(styles.menuIcon, menu && styles.open)}>
            <div className={css(styles.menuLineTop, menu && styles.open)} />
            <div className={css(styles.menuLineBottom, menu && styles.open)} />
          </div>
        </button>
      </div>

      <p className={styles.subhead}>{activeFilterText}</p>
    </>
  )
}

export default ResourcesHeader
